/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The theme\'s colours as #RRGGBB; ``*_content`` is the text colour on that accent.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface BrandColours { 
    primary: string;
    primaryContent: string;
    secondary: string;
    secondaryContent: string;
    pageBackground: string;
    text: string;
    cardBackground: string;
}
export const BrandColours_primary_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BrandColours_primaryContent_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BrandColours_secondary_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BrandColours_secondaryContent_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BrandColours_pageBackground_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BrandColours_text_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BrandColours_cardBackground_Validators: ValidatorFn[] =
    [  Validators.required, ];


